// src/components/manageRoles/CreateRoleModal.js
import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import apiUrls from "../../constants/apiUrls";
import apiCommonParams from "../../constants/apiCommonParams";
import { customJsonPost } from "../../helper/api-helper/apiHerlpers";
import { format } from "react-string-format";
import { useSmarkState } from "../../Context/KeycloakContext";

const CreateRoleModal = ({
  show,
  onHide,
  applicationId,
  siteId,
  moduleId,
  
  onSuccess,
  roleToEdit = null,
}) => {
  const [roleName, setRoleName] = useState("");
  const [roleLevel, setRoleLevel] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const userDetails = useSmarkState();
  const storedToken = localStorage.getItem("keycloakToken");
  const isEdit = !!roleToEdit;

  const generateTempId = () => `tmp_${Date.now()}`;

  useEffect(() => {
    if (roleToEdit) {
      setRoleName(roleToEdit.roleName || "");
      setRoleLevel(roleToEdit.roleLevel || 1);
    } else {
      setRoleName("");
      setRoleLevel(1);
    }
  }, [roleToEdit, show]);

const handleCreateOrEdit = async () => {
  if (!roleName.trim()) {
    toast.error("Role name is required");
    return;
  }

  setSubmitting(true);

  try {
    const roleLevelStr = "content"; // ✅ fixed role level

    const payload = {
      roleId: roleToEdit?.roleId || 0,
      roleName: roleName.trim(),
      applicationId,
      siteId,
      moduleId,
      entityType: "project",
      roleLevel: Number(roleLevel),
    };

    const url = format(
      apiUrls.saveRole,
      applicationId,
      siteId,
      roleLevelStr,
      userDetails.userId
    );

    const result = await customJsonPost(url, payload, storedToken);

    if (result?.code === "SUCCESS") {
      const savedRole = JSON.parse(result.json);

      onSuccess?.(savedRole);

      toast.success(
        isEdit
          ? `Role "${savedRole.roleName}" updated successfully`
          : `Role "${savedRole.roleName}" created successfully`
      );

      setRoleName("");
      setRoleLevel(1);
      onHide();
    } else {
      throw new Error(result?.message);
    }
  } catch (err) {
    console.error("Create/Edit role error:", err);
    toast.error(err?.message || "Failed to save role");
  } finally {
    setSubmitting(false);
  }
};




  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? "Edit Role" : "Create Role"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>Role Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter role name"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mt-3">
          <Form.Label>Role Level</Form.Label>
          <Form.Control
            as="select"
            value={roleLevel}
            onChange={(e) => setRoleLevel(Number(e.target.value))}
          >
            {[...Array(50)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleCreateOrEdit}
          disabled={submitting}
        >
          {submitting ? (isEdit ? "Updating..." : "Creating...") : isEdit ? "Update" : "Create"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateRoleModal;
